import React, { Component } from 'react'
import Select from "react-select";
import "react-select/dist/react-select.css";
import { Form, FormGroup, FormControl, ControlLabel } from 'react-bootstrap'

import { connect } from 'react-redux';
import {
    fetchSaleOrdersSignedContract,
    fetchSaleOrdersPayable,
    fetchSaleOrdersWithPayments
} from 'reducers/saleorders/saleordersActions'

import {
    SALEORDER_SIGNED_CONTRACT,
    SALEORDER_PAYABLE,
    SALEORDER_WITH_PAYMENTS
} from "constants/saleOrderTypeConst"

class SaleOrderSelect extends Component {

    constructor(props) {
        super(props);
        console.log("constructorCalled");
    }

    componentDidMount() {
        this.props.onRef(this)
    }

    componentWillUnmount() {
        this.props.onRef(undefined)
    }

    componentWillMount() {
        switch (this.props.saleOrderType) {
            case SALEORDER_SIGNED_CONTRACT:
                this.props.fetchSaleOrdersSignedContract(this.props.firstItemLabel);
                break;

            case SALEORDER_PAYABLE:
                this.props.fetchSaleOrdersPayable(this.props.firstItemLabel);
                break;

            case SALEORDER_WITH_PAYMENTS:
                this.props.fetchSaleOrdersWithPayments(this.props.firstItemLabel);
                break;

            default:
                this.props.fetchSaleOrdersSignedContract(this.props.firstItemLabel);

        }
        this.props.loadParentContent(this.props.saleOrder);
    }

    handleOnChange(saleorder) {        
        let selectedSaleOrder = saleorder == null ? { id: 0, name: "" } :
            {
                id: saleorder.value,
                name: saleorder.label,
                status: saleorder.status,
                zeroInitialQuota: saleorder.zeroInitialQuota
            };
        this.props.loadParentContent(selectedSaleOrder);
    }

    getValue() {
        return this.props.saleOrderId;
    }

    render() {
        return (
            <FormGroup controlId="formControlsSelect">
                <ControlLabel>Lote: </ControlLabel>
                <Select
                    placeholder="Seleccionar Lote"
                    name="singleSelect"
                    value={this.props.saleOrder.id}
                    options={this.props.saleorders}
                    onChange={value => this.handleOnChange(value)}
                />
            </FormGroup>
        )
    }
}

const mapStateToProps = state => ({
    saleorders: state.saleorders.items
});

export default connect(mapStateToProps,
    {
        fetchSaleOrdersSignedContract,
        fetchSaleOrdersPayable,
        fetchSaleOrdersWithPayments
    })(SaleOrderSelect);



// WEBPACK FOOTER //
// ./src/components/SaleOrderSelect/SaleOrderSelect.jsx